import { render, staticRenderFns } from "./WxCallback.vue?vue&type=template&id=ad4bb45a&scoped=true"
import script from "./WxCallback.vue?vue&type=script&lang=js"
export * from "./WxCallback.vue?vue&type=script&lang=js"
import style0 from "./WxCallback.vue?vue&type=style&index=0&id=ad4bb45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4bb45a",
  null
  
)

export default component.exports